<div id="client-email-invitation-reminder-modal-id" class="modal">
  <!-- Modal content -->
  <div class="modal-content">
    <div class="modal-header">
      <span class="close" (click)="closeInvitationReminderModal()">&times;</span>
      <br>
      <div *ngIf="showModalErrorMessages" class="container st-form text-danger">
        <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
        <div *ngFor="let errorMsg of modalErrorMessages" class="alert alert-danger" role="alert">
          <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
        </div>
        <br>
      </div>
      <div *ngIf="showModalSuccessMessages" class="container st-form text-success">
        <div *ngFor="let successMsg of modalSuccessMessages" class="alert alert-success" role="alert">
          <b>{{successMsg.field}}:</b> {{successMsg.detail}}
        </div>
        <br>
      </div>
      <br>
    </div>
    <div class="modal-body">
      <br>
      <app-st-header-title [inputVal]="'Send your Client a Reminder to Invite You!'"></app-st-header-title>
      <br>
      <app-st-span [inputVal]="'Consultant Email'"></app-st-span>
      <app-st-input-text [idVal]="'modal-consultant-email-text-id'" [label]="''" [placeHolderVal]="'Consultant Email'" [width]="'95%'"></app-st-input-text>
      <br>
      <app-st-span [inputVal]="'Client Email'"></app-st-span>
      <app-st-input-text [idVal]="'modal-client-email-text-id'" [label]="''" [placeHolderVal]="'Client Email'" [width]="'95%'"></app-st-input-text>
    </div>
    <br>
    <div class="modal-footer">
      <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
        <app-st-button-white [idVal]="'invite-email-modal-button1-id'" [label]="'Invite'" [primary]="true"
                       (click)="this.submitInvitationReminderToNonprofitClient()"></app-st-button-white>
        <app-st-button-white [idVal]="'close-modal-button1-id'" [label]="'Close'" [primary]="false"
                             (click)="closeInvitationReminderModal()"></app-st-button-white>
      </div>
    </div>
  </div>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
    </div>
    <div class="col-8">
      <br>
      <div class="container alert-primary" #goUp>
        <div class="alert alert-primary" role="alert">
          <b>Need to remind your nonprofit client to join?</b> Click here!
          <app-st-button [idVal]="'reminder-email-nonprofit-client-top-button-id'" [label]="'Email Nonprofit Client'"
                         [primary]="true" (click)="openInvitationModal()"></app-st-button>
        </div>
      </div>
      <br>
      <app-st-header-title [inputVal]="profileName"></app-st-header-title>
    </div>
  </div>
  <div *ngIf="showMessages" class="container st-form text-danger" #goUp>
    <app-st-span><b>Please validate the following: </b></app-st-span>
    <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button [idVal]="'top-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSave()"></app-st-button>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'first-name-text-id'"
                           [label]="'*First Name'" [inputVal]="firstName"
                           [placeHolderVal]="'First Name'"
                           [requiredVal]="true"
                           [maxLength]="40"
        ></app-st-input-text>
      </div>
      <div class="col">
        <app-st-input-text [idVal]="'last-name-text-id'"
                           [label]="'*Last Name'" [inputVal]="lastName"
                           [placeHolderVal]="'Last Name'"
                           [requiredVal]="true"
                           [maxLength]="40"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text-phone [idVal]="'phone-number-text-id'"
                                 [label]="'*Phone Number: (Format: 1234567890)'" [inputVal]="phoneNumber" [requiredVal]="true" [maxLength]="20"
        ></app-st-input-text-phone>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text-email [idVal]="'email-text-id'"
                                 [label]="'*Email'" [inputVal]="email" [requiredVal]="true" [disabled]="false"
                                 [maxLength]="40"
        >
        </app-st-input-text-email>
      </div>
      <div class="col">
        <app-st-input-text-email [idVal]="'confirm-email-text-id'"
                                 [label]="'*Confirm Email'"  [requiredVal]="true" [disabled]="false"
                                 [maxLength]="40"
        >
        </app-st-input-text-email>
      </div>
    </div>

    <!--
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'address-line-1-text-id'"
                           [label]="'*Address Line 1'" [inputVal]="addressLine1"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'address-line-2-text-id'"
                           [label]="'Address Line 2'" [inputVal]="addressLine2"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'city-text-id'"
                           [label]="'*City'" [inputVal]="city"
                           [disabled]="false"
                           [maxLength]="100"
        ></app-st-input-text>
      </div>
    </div>

    <app-st-span [inputVal]="'*State:'"></app-st-span><br>
    <app-st-select [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.statesList"></app-st-select>

    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'zip-code-text-id'"
                           [label]="'*Zip Code: (Formats: 12345, 123456789, or 12345-6789)'" [inputVal]="zipCode"
                           [disabled]="false"
                           [maxLength]="20"
        ></app-st-input-text>
      </div>
    </div>-->

    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'company-name-text-id'"
                           [label]="'*Company Name'" [inputVal]="companyName"
                           [requiredVal]="true"
        ></app-st-input-text>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col">
        <app-st-input-text [idVal]="'job-title-text-id'"
                           [label]="'*Job Title'" [inputVal]="jobTitle"
                           [requiredVal]="true"
        ></app-st-input-text>
      </div>
    </div>
    <br>
    <br>
    <div>
      <br>
      <p class="webtext-black"><b>Consultant Account Requirements & Access:</b></p>
      <ul class="webtext-black">
        <li><b>Consultant accounts are available by invitation only.</b> Consultants must be invited by an active nonprofit client to register for a consultant account. Once your client sends an invitation, you will receive an email with instructions to create your account.</li>
        <li><b>Early registration requests will be placed in a pending queue.</b> If you complete the registration process before receiving an invitation from a nonprofit client, your account request will remain pending until a client invites you and activates your access.</li>
        <li><b>A valid payment method is required.</b> Consultants must maintain an active credit card on file to keep their account in good standing.</li>
        <li><b>Free access is sponsored by active nonprofit clients.</b> Consultant accounts are provided at no cost while the consultant is connected to at least one nonprofit organization with an active Scalanthropy subscription.</li>
        <li><b>Billing and account status.</b> If a consultant no longer has any active nonprofit clients with valid Scalanthropy subscriptions, the consultant account will automatically convert to a paid monthly subscription and the credit card on file will be charged according to the current consultant pricing plan. Failure to maintain a valid payment method may result in account suspension or deactivation.</li>
        <li><b>Need an invitation? </b><a class="invite-link" (click)="openInvitationModal()">Click here</a> to request that your nonprofit client invite you to create a consultant account.</li>
      </ul>
    </div>
    <br>
    <div class="row pt-3">
      <div class="col">
        <a id="terms-and-conditions-alink-id" class="terms-conditions-link" href="https://www.scalanthropy.com/terms-conditions" target="_blank">View Terms and Conditions</a>
        <br>
        <div class="form-check">
          <input class="form-check-input radio-button-properties" type="radio" value="true" id="legal-agreement-radio-button-id"
                 (click)="toggleLegalAgreement()" [checked]="termsAndConditionsRadioButton">
          <app-st-span [inputVal]="'I Agree'"></app-st-span>
        </div>
      </div>
    </div>
    <br>
    <app-st-button-back-to-top></app-st-button-back-to-top>
    <br>
    <br>
    <div *ngIf="showSuccessMessages" class="container st-messages-form text-success" #goUp>
      <app-st-span [inputVal]="'Your messages:'" ></app-st-span>
      <div *ngFor="let successMsg of successMessages" class="alert alert-success" role="alert">
        <b>{{successMsg.field}}:</b> {{successMsg.detail}}
      </div>
      <br>
    </div>
    <div *ngIf="showMessages" class="container st-messages-form text-danger" #goUp>
      <app-st-span [inputVal]="'Please validate the following: '" ></app-st-span>
      <div *ngFor="let errorMsg of messages" class="alert alert-danger" role="alert">
        <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
      </div>
      <br>
    </div>
    <br>
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'bottom-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button [idVal]="'bottom-save-button-id'" [label]="'Submit'" [primary]="true"
                     (click)="this.onSave()"></app-st-button>
    </div>
  </div>
</div>


